<template>
    <div v-loading="loading">
        <div class="head">
           <div class="header">
            <a href="https://cloud.hzjly.cn/#/Index" class="logo-box">
                <div class="logo"></div>
            </a>
            <div class="logo-txt">支付</div>
            <div class="user">
                <el-dropdown trigger="hover"><span class="el-dropdown-link"><span>{{userName}}</span>
                    <i class="el-icon-arrow-down el-icon--right"></i></span>
                <el-dropdown-menu>
                    <a href="https://passport.hzjly.cn/#/loginout">
                        <el-dropdown-item>
                            <i class="iconfont icon-exit"></i>
                            <span>退出</span>
                        </el-dropdown-item>
                    </a>
                </el-dropdown-menu>
                </el-dropdown>
            </div></div>
        </div>
        <div class="content-one">
          <div class="title">待支付订单
                <div class="user-2">
                    <b style="font-size: 14px;font-family: Adobe ">应付 <span style="color: #1f8eeb">￥{{totalamout}}</span></b>
                </div>
            </div>
            <div class="item-box">
            <el-table
                    :data="tableData"
                    class="el-table"
                    border
                   :header-cell-style="rowClass"
            >
               <el-table-column label="产品"
                                prop="subject"
                                align="center"
                                width="180px" >
            </el-table-column>
                <el-table-column
                       label="订单内容"
                       width="180px"
                       prop="sn"
                       align="center"
                >
                </el-table-column>
                <el-table-column label="时长"
                                 prop="time"
                                 width="180px"
                                 align="center">
                </el-table-column>
                <el-table-column label="短信数量"
                                 v-if="msgnum!=''"
                                 width="180px"
                                 align="center">
                    <template slot-scope="scope">
                        {{msgnum}}
                    </template>

                </el-table-column>
                <el-table-column label="总额"  align="right"
                ><span style="color: #3b97ec;font-size: 12px">￥{{this.totalamout}}</span>
                </el-table-column>
            </el-table>
            </div></div>
        <div class="content-two">
            <div class="title">使用余额</div>
            <div style="height: 50px">

                <span v-if="Number(this.money)>=Number(this.totalamout)"><el-checkbox  class="check" v-model="checked">使用账户余额抵扣（当前账户余额 <span style="color: #1f8eeb">￥{{money}} </span>） </el-checkbox></span>
                <span v-if="Number(this.money)<Number(this.totalamout)">
            <el-checkbox  class="check" v-model="checked"> 使用账户余额抵扣（当前余额<b style="color:#fa382b" > 不足 </b>），请选择其他支付方式
              <span v-if="!$common.checkPower('54eed7d9-2ca9-4c7f-b302-2a30bac736eb')">
                  或者进行
              </span>
        <el-link v-if="!$common.checkPower('54eed7d9-2ca9-4c7f-b302-2a30bac736eb')" class="el-link"  :underline="false" href="https://paycenter.hzjly.cn/#/pay" >充值</el-link></el-checkbox>
      </span><div class="txt">抵扣 <span style="color: #3b97ec ">￥{{totalamout}}</span></div>
        </div>
        </div>
        <div class="content-three">
            <div class="title">其他支付方式</div>
            <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
               <el-tab-pane  class="el-tab-pane" label="支付宝" name="first"  :disabled="false" @click="aliPay" >
                   <el-form class="from">
                       <el-radio v-model="radio"  class="radio" label="1"><span style="font-size: 16px;text-align: center" >支付宝</span></el-radio>
                       <div class="image">
                       <el-image
                           style="width: 29px;height: 29px;"
                           :src="url"></el-image></div>
                   </el-form>
               </el-tab-pane>
                <el-tab-pane class="el-tab-pane" label="个人网银" name="second" :disabled="true"></el-tab-pane>
                <el-tab-pane class="el-tab-pane" label="企业网银" name="third" :disabled="true"></el-tab-pane>
                <el-tab-pane class="el-tab-pane" label="线下汇款" name="forth" :disabled="true"></el-tab-pane>
            </el-tabs>
        </div>
        <div class="footer-box">
            <div class="foot">
                <span class="foot1">实付金额 <span style="color: #1f8eeb;font-size: 24px" >￥{{totalamout}}</span></span>
                <span class="foot2" v-if = "checked == true"><el-button type="primary" class="button" @click="payOrder"><div class="test">支付</div> </el-button></span>
                <span class="foot2" v-if="checked == false"><el-button type="primary" class="button" @click="aliPay"><div class="test">支付</div></el-button></span>
                </div></div>
        </div>

</template>
<script>
    export default {
        name: 'Order',
        data() {
            return {
                msgnum:'',
                tableHeight:50,
                url: "https://static.hzjly.cn/CloudSMS/img/order.png",
                loading: false,
                activeName: 'first',
                checked: false,
                value: " ",
                sn: "",//设备SN
                totalamount: "",
                subject: "",
                time:"",
                tableData: [],
                userName: "", //用户名
                money: 0 ,//余额
                guid: "",
                radio:"1",
                disabled:"false",
                commGuid:"",
                totalAmout:"",
                DevGuids:"",
                vipPlan: "",
                itemBody: "",
                userguid:"",
                tradeno:"",
                seconds: 1//执行结束时间

            };
        },
        created: function () {
            this.$emit('header', false);
            this.$emit('footer', false);
            this.getData();
            this.getUser();
            this.getMoney();
        },
        methods: {
            getUser() {
                let user = document.cookie;
                const cookieReg = /UserName=(\w.[^;]*)/; //cookie匹配
                user = cookieReg.exec(user)[1];
                this.userName = user;
            },
            getMoney() {
                this.$axios.get("https://cloudsms.hzjly.cn/api/Account/AccountInfoForTel",{
                    params:{}
                })
                    .then(res => {
                        this.loading = false;
                        let data = JSON.parse(res.data).results.result.balance;
                        this.money = data.toFixed(2);
                    })
                    .catch(err => {
                        this.loading = false;
                        this.$message({
                            message: "连接失败",
                            type: "error"
                        });
                        //console.log(err);
                    })
            }, //获取余额
            handleClick(tab, event) {
                // console.log(tab,event);
            },
            getData() {
                function getUrlKey(name) {
                    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
                }//获取地址栏中的参数
                this.loading = false;
                this.tableData = [{
                    subject: getUrlKey('fmsubject'),
                    sn: getUrlKey('fsn'),
                    time: getUrlKey('fmtime'),
                    totalamout: getUrlKey('fmtotalamout'),
                }]
                this.totalamout = getUrlKey('fmtotalamout');
                this.msgnum = getUrlKey('msgnum')||'';
                this.guid = getUrlKey('guid');
                this.userguid = getUrlKey('fuserguid');
                this.tradeno = getUrlKey('tradeno');
               //console.log(this.tradeno);
            },

            payOrder() {

                const getCookie = name => {
                    let user = document.cookie;
                    let reg = name + '=(\\w.[^;]*)';
                    const cookieReg = new RegExp(reg);
                    return cookieReg.exec(user)[1];
                }; //获取cookie内的参数

                this.$confirm('是否确认继续扣款操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    this.$axios.get("https://passport.hzjly.cn/api/User_COMM_Join/GetCommGuidByUserGuid",{
                        params:{guid:getCookie("UserInfo"),}
                    })
                    .then(res => {

                        let data = JSON.parse(res.data).results.result;
                        if(this.totalamout==data[0].unitprice){

                            this.$axios
                            .post("https://cloudsms2.hzjly.cn/api/Account_Charge/RenewCharge", {
                                devguid: this.guid,
                            })
                            .then(res => {
                                this.loading=false;
                                let data = JSON.parse(res.data).results;
                                if (data.result) {

                                    this.$message({
                                        message: "续费成功！",
                                        type: "true",
                                    })
                                    let newWindow = window.open("about:blank");
                                    let timekeeping = setInterval(()=>{
                                        if(this.seconds <= 0){
                                            let url="https://cloudsms2.hzjly.cn/#/dev"
                                            newWindow.location.href=url;
                                            clearInterval(timekeeping);
                                        }else{
                                            this.seconds--;
                                        };
                                    },1000);
                                }
                                else {
                                    this.$message({
                                        message: "续费失败！",
                                        type: "false"
                                    })
                                }
                            })

                        }else{
                            this.loading=false;
                            this.$message({
                                message: "支付金额不符",
                                type: "error"
                            });
                        }
                    })
                    .catch(err => {
                        this.loading = false;
                        this.$message({
                            message: "连接失败",
                            type: "error"
                        });
                        //console.log(err);
                    })



                }).catch(() => {

                });






            },//余额续费
            aliPay(){

                const getCookie = name => {
                    let user = document.cookie;
                    let reg = name + '=(\\w.[^;]*)';
                    const cookieReg = new RegExp(reg);
                    return cookieReg.exec(user)[1];
                }; //获取cookie内的参数


                this.$confirm('是否确认继续扣款操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    this.$axios.get("https://passport.hzjly.cn/api/User_COMM_Join/GetCommGuidByUserGuid",{
                        params:{guid:getCookie("UserInfo"),}
                    })
                    .then(res => {
                        this.loading = false;
                        let data = JSON.parse(res.data).results.result;
                        if(this.totalamout==data[0].unitprice){

                            let newWindow = window.open("about:blank");
                            this.loading = true;
                            this.$axios.post("https://cloudsms2.hzjly.cn/api/Alipay/PayRequestCOMMGuids", {
                                tradeno: this.tradeno,
                                subject: "物联网卡续费",
                                totalAmout: this.totalamout,
                                commGuid: this.userguid,
                                DevGuids: this.guid,
                                vipPlan: "",
                                itemBody: ""
                            })
                            .then(res => {
                                this.loading = false;
                                let data = JSON.parse(res.data).results;
                                if (data.result) {
                                    newWindow.location =
                                      "https://CloudSMS2.hzjly.cn/api/Charge/PayRequestDev?fmtotalamout=" +
                                      this.totalamout +
                                      "&fmtradeno=" +
                                      this.tradeno +
                                      "&fmsubject=物联网卡续费&fmitemBody=";
                                    console.log(newWindow.location);
                                } else {
                                    this.$message({
                                        message: data.data,
                                        type: "warning"
                                    });
                                }
                            })

                        }else{
                            this.$message({
                                message: "支付金额不符",
                                type: "error"
                            });
                        }
                    })
                    .catch(err => {
                        this.loading = false;
                        this.$message({
                            message: "连接失败",
                            type: "error"
                        });
                        //console.log(err);
                    })


                }).catch(() => {

                });





            },//支付宝支付
            rowClass({row,rowIndex}){
                console.log(rowIndex)
                return{background:'#eef2f4',height:'2.5vh'}
            }
        }
    }
</script>
<style scoped>
    .head{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 50px;
        background: #fff;
        box-shadow: 0 0 10px #ccc;
        /*display: flex;*/
      /*  min-width: 500px;*/

    }
   .header{
       width: 1202px;
       height: 50px;
       line-height: 50px;
       color: #444;
       text-align: right;
       margin:  0 auto;

    }
    .logo-box{
        width: 95px;
        height: 27px;
        margin: 11.5px 0 0 20px;
        float: left;
    }
    .logo{
        width: 100%;
        height: 100%;
        background: url(../assets/img/logo.png);
    }
    .logo-txt{
        float: left;
        border-left: 1px solid #444444;
        padding-left: 10px;
       font-size: 16px;
        line-height: 20px;
        margin: 16px 0 0 10px;
    }
    .user{
        height: 50px;
        line-height: 50px;
        color: #444;
        float: right;
        width: 110px;
    }
    .content-one{
        background-color: #ffffff;
        width: 1200px;
        height: 160px;
        border: 1px solid #e4e5e5;
        margin-top: 65px;
        position: relative;
    }
    .item-box{
        padding-top: 13px ;
        padding-left: 12px;
        padding-right: 12px;
    }
  .el-table{
        border: 1px solid #e5e5e5;
        width: 100%;
        height: 86px;

    }
   .user-2{
        float:right;

    }
    .content-two{
        background-color: #ffffff;
        width: 1200px;
        height: 100px;
        border: 1px solid #e4e5e5;
        margin-top: 9px;
        position: relative;
    }
    .content-three{
        background-color: #ffffff;
        width: 1200px;
        height: 210px;
        border: 1px solid #e4e5e5;
        margin-top: 9px;
        position: relative;
    }
    .tabs{
        margin-top: 19px;
        font-size: 14px;
        padding-left: 10px;
        padding-right: 10px;
        position: relative;
    }
    .title{
        width: calc(100% - 30px);
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        padding: 0 15px;
        border-radius: 5px 5px 0 0;
        border-bottom: 1px solid #e4e5e5;
    }
    .check{
        padding-left: 15px;
        height: 50px;
        line-height: 50px;
    }
    .el-link{
        padding-top: 18px;
        padding-bottom: 21px;
        color: #51a0ee;
        text-decoration: underline;

    }
    .txt{
        height: 50px;
        line-height: 50px;
        /*margin: 0  320px;*/
        padding: 0 10px;
        float: right;
        cursor: pointer;

    }

    .footer-box{
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 100%;
        height: 87px;
        box-shadow: 0 0 10px #ccc;
        background-color: #ffffff;
    }
    .foot{
        text-align: right;
        width: 1202px;
        margin:  0 auto;
        height: 87px;
        line-height: 87px;
        /*margin: 0  320px;*/

        cursor: pointer;
        color: #444;
    }
   /* .foot1{
        padding-right: 80px;
    }*/
    .foot2{
     padding-left: 30px;
    }
    .button{
        background-color: #1f8eeb;
        width: 150px;
        height: 40px;
        margin-top: -20px;
    }
    .from{
        width: 190px;
        height: 58px;
        background-color: #ecf5fc;
        border: 1px solid #e8ebed;
    }
    .radio{
        padding: 18px;
    }

    .image{
        padding-left: 145px;
        margin-top:-40px ;
    }
</style>
